<template>
    <div class="chat-detail-wrapper" :class="{ 'question-active': isCurQuestion }">
        <div class="user-chat-item">
            <div class="user-icon"><img :src="userIcon" /></div>
            <div class="detail-text">
                <div class="log-time">{{ transTime }}</div>
                <div class="user-text">
                    {{ data.userQuestion }}
                    <div class="en-user-ques" v-show="isTranslate">
                        {{ data.questionTranslate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="xy-chat-item">
            <div class="detail-text">
                <div class="log-time">{{ transTime }}</div>
                <component
                    :is="item.widgetType"
                    v-for="(item, idx) in answerText"
                    :key="idx"
                    :data="item.content"
                    :isTranslate="isTranslate"
                    :isEn="data.addData.lang === 'en' ? true : false"
                    :enData="enAnswerText[idx] && enAnswerText[idx].content"
                ></component>
                <component :is="data.addData.showOption" v-if="data.addData.showOption" :data="data.addData.shortcutBar"></component>
            </div>
            <div class="user-icon"><img :src="xiaoyueIcon" /></div>
        </div>
    </div>
</template>

<script>
import TextShape from "./widgets/TextShape";
import HotQuestionShape from "./widgets/HotQuestionShape";
import FormShape from "./widgets/FormShape";
import ToolShape from "./widgets/ToolShape";
import OptionShape from "./widgets/OptionShape";

import { widgetsType } from "@/views/zhiji/js/common/constants.js";

// 这期只处理文本，热点问题组件详情
const widgetObj = {
    text: "TextShape",
    hotQuestion: "HotQuestionShape",
    form: "FormShape",
    tool: "ToolShape",
    ticket: "FormShape"
};

export default {
    name: "",
    props: ["data", "answer", "isTranslate", "curQuestion", "curQuestionCreatetime"],
    components: {
        TextShape,
        HotQuestionShape,
        FormShape,
        ToolShape,
        OptionShape
    },
    data() {
        return {
            transTime: this.transLogTime(),
            answerText: this.getAnswerText(),
            enAnswerText: this.getEnAnswerText(),
            xiaoyueIcon: this.zhiji.staticPath() + "zhiji-icon.png",
            userIcon: this.zhiji.staticPath() + "user-icon.png",
        };
    },
    computed: {
        isCurQuestion() {
            return (
                this.curQuestion &&
                this.data.userQuestion &&
                this.data.userQuestion == this.curQuestion &&
                this.curQuestionCreatetime === this.data.addData.createTime
            );
        },
    },
    methods: {
        transLogTime() {
            return this.zhiji.dateFormat(new Date(this.data.time));
        },
        getAnswerText() {
            return this.getAnswerWidgetData(this.data.addData.answerDetail);
        },
        getEnAnswerText() {
            return this.getAnswerWidgetData(this.data.addData.enAnswerDetail);
        },
        getAnswerWidgetData(answer) {
            let currentAnswer = answer ? JSON.parse(answer) : [];
            // 组件详情数据转换
            return this.cvtWidgetsData(currentAnswer);
        },
        cvtWidgetsData(data) {
            let newData = [];
            newData = data.map(item => {
                return {
                    widgetType: widgetObj[widgetsType[item.tpl_type]],
                    content: this.cvtWedgetContent(item.content, widgetsType[item.tpl_type])
                };
            });
            return newData;
        },
        cvtWedgetContent(content, type) {
            // 各组件数据转换机
            let handle = {
                text: this.textContentData,
                hotQuestion: this.hotQuestionContentData,
                form: this.formContentData,
                tool: this.toolContentData,
                ticket: this.ticketContentData
            };

            return type && handle[type].call(null, content, type);
        },
        textContentData(content) {
            let itemData = [];
            itemData = content.map(item => {
                return {
                    itemType: "text",
                    text: item.text
                };
            });
            return itemData;
        },
        hotQuestionContentData(content, type) {
            let itemData = [];
            itemData = content.map(item => {
                return {
                    ...item,
                    itemType: widgetObj[type],
                    formTemplateId: item.form_template_id,
                    question: this.cvtQuestionListData(item.question)
                };
            });
            return itemData;
        },
        ticketContentData(content, type) {
            return content.map(() => {
                return {
                    itemType: widgetObj[type],
                    type: type
                };
            });
        },
        formContentData(content, type) {
            return content.map(() => {
                return {
                    itemType: widgetObj[type],
                    type: type
                };
            });
        },
        toolContentData(content, type) {
            return content.map(item => {
                return {
                    itemType: widgetObj[type],
                    toolData: item.tool_data ? JSON.parse(item.tool_data) : {}
                };
            });
        },
        cvtQuestionListData(question) {
            let ret = [];
            ret = question.map(item => {
                return {
                    questionType: item.type,
                    questionId: item.question_id,
                    displayText: item.question_display_text
                };
            });

            return ret;
        }
    }
};
</script>

<style lang="less" scoped>
.chat-detail-wrapper {
    &.question-active {
        .detail-text {
            .user-text {
                color: #2ec2ff;
            };
        };
    };
    .user-chat-item {
        margin-bottom: 24px;
        display: flex;
        justify-content: flex-start;
    }

    .detail-text {
        margin-left: 15px;
        width: 100%;

        .log-time {
            font-size: 12px;
            color: #9b9ba3;
            margin-bottom: 4px;
            text-align: left;
        }

        .user-text {
            position: relative;
            background: #e9ecf4;
            border-radius: 6px;
            padding: 9px 16px;
            border: 1px solid #d8e4f0;
            max-width: 510px;
            width: fit-content;
            float: left;
            word-wrap: break-word;

            &:after {
                position: absolute;
                top: 10px;
                left: -6px;
                display: inline-block;
                background: #e9ecf4;
                content: "";
                width: 6px;
                height: 7px;
                background: url("@{zhijiStaticImagePath}class-spr.png") no-repeat;
                background-position: -370px -72px;
                transform: rotate(180deg);
            }
        }
    }

    .xy-chat-item {
        justify-content: flex-end;
        margin-bottom: 24px;
        display: flex;

        .detail-text {
            margin: 0 15px 0 0;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            .log-time {
                text-align: right;
            }

            .user-text {
                background: #fff;
                border: 1px solid #d8e4f0;
                float: right;
                &:after {
                    right: -6px;
                    background-position: -370px -80px;
                    transform: rotate(180deg);
                }
            }
        }
    }

    .user-icon {
        width: 40px;
        height: 40px;
    }

    .en-user-ques {
        border-top: 1px solid #d8e4f0;
        margin-top: 8px;
        padding-top: 4px;
    }
}

.xiaoyue-detail {
    justify-content: flex-start;
}
</style>
